import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
var logoHeight = 32;
var imageDimensions = {
  vertical: {
    height: 250,
    width: null
  },
  'two-column': {
    height: 320,
    width: 320
  },
  'three-column': {
    height: 280,
    width: 320
  }
};
export var image = _ref => {
  var layout = _ref.layout;
  return /*#__PURE__*/css("display:flex;flex-direction:column;position:relative;width:", imageDimensions[layout].width ? "".concat(imageDimensions[layout].width, "px") : '100%', ";min-width:", imageDimensions[layout].width ? "".concat(imageDimensions[layout].width, "px") : '100%', ";max-width:100%;text-align:center;text-decoration:none;height:", imageDimensions[layout].height, "px;");
};
export var imageContainer = {
  name: "1gyskmn",
  styles: "height:100%;display:flex;&::after{position:absolute;right:0;bottom:0;left:0;width:100%;height:87px;background-image:linear-gradient(180deg,transparent,rgba(0,0,0,0.6));content:'';}"
};
export var imageUnderlay = _ref2 => {
  var _ref2$hasDevelopmentL = _ref2.hasDevelopmentLogo,
    hasDevelopmentLogo = _ref2$hasDevelopmentL === void 0 ? false : _ref2$hasDevelopmentL,
    layout = _ref2.layout;
  return /*#__PURE__*/css("position:absolute;background-color:", colors.neutral.background.default, ";width:", imageDimensions[layout].width ? "".concat(imageDimensions[layout].width, "px") : '100%', ";height:", imageDimensions[layout].height - (hasDevelopmentLogo ? logoHeight : 0), "px;object-fit:cover;");
};
export var logo = function logo() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    backgroundColour = _ref3.backgroundColour,
    foregroundColour = _ref3.foregroundColour;
  return /*#__PURE__*/css("height:", logoHeight, "px;width:100%;background-color:", backgroundColour, ";color:", foregroundColour, ";");
};
export var missingImage = /*#__PURE__*/css("display:flex;flex-direction:row;justify-content:center;align-items:center;gap:8px;height:75%;background-color:", colors.neutral.subdued.default, ";color:", colors.neutral.medium.default, ";");
export var logoImage = {
  name: "4j3isa",
  styles: "height:100%;max-width:100%;"
};
export var contents = {
  name: "14mifsi",
  styles: "display:flex;flex-direction:column;z-index:1;height:100%;width:100%;"
};